 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'


import useAtmosphere from '../hooks/useAtmosphere'
import {MenuPosition} from '../hooks/useCoords'
import useMenu from '../hooks/useMenu'
import {PortalStatus} from '../hooks/usePortal'
import lazyPreload from '../utils/lazyPreload'
import setPreferredTeamId from '../utils/relay/setPreferredTeamId'
import NewMeetingDropdown from './NewMeetingDropdown'
import NewMeetingTeamPickerAvatars from './NewMeetingTeamPickerAvatars'

const SelectTeamDropdown = lazyPreload(
  () =>
    import(
      /* webpackChunkName: 'SelectTeamDropdown' */
      './SelectTeamDropdown'
    )
)









const NewMeetingTeamPicker = (props) => {
  const {selectedTeamRef, teamsRef, onSelectTeam, positionOverride, customPortal} = props
  const {togglePortal, menuPortal, originRef, menuProps, portalStatus} = useMenu(
    _nullishCoalesce(positionOverride, () => ( MenuPosition.LOWER_RIGHT)),
    {
      isDropdown: true
    }
  )

  const atmosphere = useAtmosphere()

  const handleSelectTeam = (teamId) => {
    setPreferredTeamId(atmosphere, teamId)
    onSelectTeam(teamId)
  }

  const selectedTeam = useFragment(
    graphql`
      fragment NewMeetingTeamPicker_selectedTeam on Team {
        ...NewMeetingTeamPickerAvatars_team
        name
      }
    `,
    selectedTeamRef
  )

  const teams = useFragment(
    graphql`
      fragment NewMeetingTeamPicker_teams on Team @relay(plural: true) {
        ...SelectTeamDropdown_teams
        id
        name
      }
    `,
    teamsRef
  )

  const {name} = selectedTeam
  return (
    React.createElement(React.Fragment, null
      , React.createElement(NewMeetingDropdown, {
        icon: React.createElement(NewMeetingTeamPickerAvatars, { teamRef: selectedTeam,} ),
        label: name,
        onClick: togglePortal,
        onMouseEnter: SelectTeamDropdown.preload,
        disabled: teams.length === 0,
        ref: originRef,
        title: 'Team',
        opened: [PortalStatus.Entering, PortalStatus.Entered].includes(portalStatus),}
      )
      , menuPortal(
        customPortal ? (
          customPortal
        ) : (
          React.createElement(SelectTeamDropdown, {
            menuProps: menuProps,
            teams: teams,
            teamHandleClick: handleSelectTeam,}
          )
        )
      )
    )
  )
}

export default NewMeetingTeamPicker
